import { request } from '@pb/utils'

export const apiInitAdyen = async (): Promise<any> => {
  const { data } = await request.get('payments/initAdyen')

  return data
}
